export const editorSearchActionTypes = {
  OPEN_SEARCH_PANEL: 'OPEN_SEARCH_PANEL',
  CLOSE_SEARCH_PANEL: 'CLOSE_SEARCH_PANEL',
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};
